import React from 'react';
import { Download, ExternalLink, Presentation, FileText } from 'lucide-react';
import { Button } from '../ui/button.jsx';

/**
 * PPTX-only packages: download / open (no in-browser Office embed — S3 presigned URLs are not compatible).
 * Web lessons use slide decks from content.json modules via SlideDeckViewer.
 */
function PptxEmbedViewer({ viewUrl, title, fileName }) {
  if (!viewUrl) {
    return (
      <div className="flex flex-col items-center justify-center min-h-[360px] text-center px-6">
        <Presentation className="w-12 h-12 text-emerald-700 mb-4" />
        <h3 className="text-lg font-semibold text-[#1a4a1a] mb-2">Presentation unavailable</h3>
        <p className="text-slate-600 text-sm max-w-md leading-relaxed">
          This package does not have a linked deck yet.
        </p>
      </div>
    );
  }

  return (
    <div className="space-y-6">
      <div className="flex flex-wrap items-start justify-between gap-4">
        <div>
          <h2 className="text-xl font-bold text-[#1a4a1a]">{title || 'Presentation'}</h2>
          {fileName && <p className="text-sm text-slate-500 mt-1">{fileName}</p>}
        </div>
        <div className="flex flex-wrap gap-2">
          <Button asChild variant="outline" size="sm">
            <a href={viewUrl} target="_blank" rel="noopener noreferrer">
              <ExternalLink className="w-4 h-4 mr-1" />
              Open
            </a>
          </Button>
          <Button asChild size="sm" className="bg-emerald-600 hover:bg-emerald-700">
            <a href={viewUrl} download={fileName || undefined}>
              <Download className="w-4 h-4 mr-1" />
              Download
            </a>
          </Button>
        </div>
      </div>

      <div className="rounded-xl border border-amber-200 bg-amber-50/80 p-6 flex gap-4">
        <FileText className="w-8 h-8 text-amber-800 shrink-0" />
        <div className="text-sm text-amber-950 space-y-2">
          <p className="font-semibold">Web lesson not available</p>
          <p className="leading-relaxed text-amber-900/90">
            This package is a PowerPoint file only. Use Open or Download above to view the deck.
          </p>
        </div>
      </div>
    </div>
  );
}

export default PptxEmbedViewer;
